/*
*
* 权限枚举命名规则：
*               页面权限：一级路径:页面路径     例如： operation:order   表示运营管理里面的订单管理， 页面路径： /#/operation/order
*               按钮权限：一级路径:页面路径:按钮功能名称       例如：userManage:agent:addAAgent     表示用户管理里面的代理商管理创建A级代理商
*
* */

const auth = {
    MERCHANT: ["operation:bankOrder"],
    // 运营权限
    OM: [
        "datas:summary", // 汇总数据
        "datas:ranking", // TOP排行榜
        "datas:docForm", // 网点报表
        "datas:agentForm", // 代理商报表
        "datas:countData", // 计费数据分析
        "datas:operateOffice", // 运营代办
        "datas:platformDailyReport", // 平台运营日报表
        "datas:financeForm", // 平台财务报表
        "datas:distributionProportion", // 平台营运分布占比
        "datas:orderTrendAnalysis", // 平台订单趋势分析
        "datas:yesterdayData", // 昨日营运数据
        "datas:equipmentAnalysis", // 平台设备趋势分析
        "datas:profit", // 数据订单报表
        "operation:bankOrder", // 宝订单管理
        "operation:retainedOrder", // 留存订单管理
        "operation:order", // 线订单管理
        "operation:order", // 已购买订单管理
        "operation:recharge", // 充值管理
        "operation:agentBuyOrder", // 代理购买订单
        "operation:base", // 底座管理
        "operation:charger", // 充电线管理
        "operation:reset", // 设备重置
        "operation:deviceRecord", // 设备操作管理
        "operation:doc-list", // 网点管理
        "operation:area", // 区域代理
        "operation:white-list", // 白名单管理
        "operation:question", // 问题反馈
        "operation:join", // 加盟合作
        "operation:PlatformAdv", // 平台投放广告
        "operation:platformAdvAudit", // 平台投放广告审核
        "operation:agentAdv", // 代理商投放广告
        "operation:agentAdvAudit", // 代理商投放广告审核
        "operation:testingAbnormal", // 检测异常列表
        "operation:businessTransfer", // 商家转移记录
        "operation:abnormalLeaseRecord", // 异常租借记录
        "operation:testing", // 宝重码检测表
        "operation:adManager", // 广告管理
        "operation:serviceCondition", // 宝使用状况
        "propaganda:banner", // 横幅管理
        "propaganda:putIn", // 横幅投放审核
        "propaganda:column", // 栏目管理
        "propaganda:article", // 文章管理
        "finance:platformAccount", // 平台账户余额
        "finance:billRecord", // 员工账单
        "userManage:agent", // 代理商管理
        "userManage:userList", // 用户列表
        "userManage:staffList", // 员工列表
        "log:login", // 登录日志
        "log:oprea", // 操作日志
        "conv:conv-rule", // 积分规则
        "conv:conv-record", // 积分记录
        "message:messageControl", // 消息控制
        "message:smsTemplate", // 短信模版管理
        "message:groupSending", // 群发功能
        "message:voiceAlert", // 语音提醒模块
        "system:business", // 业务配置
        "system:drawFeeConfig", // 提现手续费配置
        "system:setting", // 设备设置
        "system:optionConfig", // 选项配置
        "productStorage:equipmentModel", // 设备型号设置
        "productStorage:deviceInventory", // 设备库存管理
        "productStorage:transferCheck", // 划拨出库审核
        "productStorage:purchaseCheck", // 采购申请审核
        "productStorage:deviceForm", // 设备表
        "productStorage:inventoryRecord", // 库存记录
        "productStorage:deviceReportForm", // 设备报表
        "productStorage:productStorageConfig", // 仓储配置
        "productStorage:series", // 系列管理
        "productStorage:virtualCode", // 虚拟码管理
        "productStorage:deviceFaultRepair", // 设备故障维修
        "main", // 个人中心
    ],
    // 客服权限
    CSD: [
        "operation:userPaymentRecord", // 用户支付记录
        "operation:userPaysForOrder", // 用户支付订单
        "operation:bankOrder", // 宝订单管理
        "operation:retainedOrder", // 留存订单管理
        "operation:order", // 线订单管理
        "operation:order", // 已购买订单管理
        "operation:recharge", // 充值管理
        "operation:base", // 底座管理
        "operation:charger", // 充电线管理
        "operation:deviceRecord", // 设备操作管理
        "operation:doc-list", // 网点管理
        "operation:question", // 问题反馈
        "finance:platformAccount", // 平台账户余额
        "conv:conv-record", // 积分记录
        "main", // 个人中心
    ],
    // 财务权限
    FD: [
        "datas:summary", // 汇总数据
        "datas:ranking", // TOP排行榜
        "datas:countData", // 计费数据分析
        "datas:financeOffice", // 财务代办
        "datas:platformDailyReport", // 平台运营日报表
        "datas:financeForm", // 平台财务报表
        "datas:distributionProportion", // 平台营运分布占比
        "datas:orderTrendAnalysis", // 平台订单趋势分析
        "datas:yesterdayData", // 昨日营运数据
        "datas:profit", // 数据订单报表
        "operation:bankOrder", // 宝订单管理
        "operation:retainedOrder", // 留存订单管理
        "operation:order", // 线订单管理
        "operation:order", // 已购买订单管理
        "operation:recharge", // 充值管理
        "operation:agentBuyOrder", // 代理购买订单
        "operation:depositStatistics", // 押金统计
        "finance:withdraw", // 提现管理
        "finance:bill", // 订单流水
        "finance:agentBill", // 代理商账单
        "finance:agentBill", // 押金记录
        "finance:platformAccount", // 平台账户余额
        "finance:billRecord", // 员工账单
        "main", // 个人中心
    ],
    // 超级管理员权限
    ADMIN: [],
    // 测试权限
    STE: []
};

export default auth;



// WEBPACK FOOTER //
// ./src/auths.js